const lockPageContainer = document.querySelector('.page-lock-section');
const lockPageInput = document.querySelector('.page-lock-input');
const lockPageButton = document.querySelector('.page-lock-button');
const lockPageError = document.querySelector('.page-lock-error');
const lockPageMain = document.querySelector('#pahlowmedia-lock-main');

lockPageButton.addEventListener('click', (e) => {
  e.preventDefault();
  if(lockPageInput.value === window.pageLock.password){
    lockPageMain.style.display = 'block';
    lockPageContainer.style.display = 'none';
  }else{
    lockPageError.style.display = 'block';
  }
})